import { defineComponent as _defineComponent } from 'vue'
import { Row } from '@warrenbrasil/nebraska-web';
import { InstrumentAvatar } from '@/modules/trade/components/InstrumentAvatar';

import { InstrumentType } from '@/modules/trade/types/bff';
import { AssetDetailsDescription } from '@/modules/trade/services/portability';

interface Props {
  symbol: string;
  description: AssetDetailsDescription;
  type: InstrumentType;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AssetRow',
  props: {
    symbol: null,
    description: null,
    type: null
  },
  setup(__props: any) {



// Uses a special character &#x200B; that was no width but has height to fill the right title,
// so it shows the right subtitle at the bottom of the row not at the top
const emptyRightTitle = '​';

return { __sfc: true,emptyRightTitle, Row, InstrumentAvatar }
}

})